import './scss/vitrine.scss'

import { Counter } from "./components/Counter"
import { DadosProduto } from "./components/DadosProduto"
import type { MostruarioEspacadaProps } from '../../types/vitrineApp.props'
import { Device } from '../../data/device'
import { TitleCtn } from '../../components/TitleCtn'
import { MidiaProdutoVitrine } from '../../components/MidiaProdutoVitrine'
import { getLinkProduto } from '@/utils/getLinkProduto'
import { FavoriteButton } from '@/components/vitrine/components/Favorite-button'

export function MostruarioEspacada({
    hostImagem,
    produtos,
    exibeQuantidadeEstoque,
    tituloVitrine,
    vitrineMacro,
    exibeValoresSomenteLogado,
    precoPrincipal,
    vitrineButtonAddToCart,
    device,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    width,
    height,
    className
}: Readonly<MostruarioEspacadaProps>) {
    const isDesktop = device === Device.DESKTOP

    const getAClass = (index: number) => {
        if (isDesktop) {
            return index % 2 === 0 ? "product-one-of-two" : "product-two-of-two last"
        } else {
            return index % 3 === 0 ? "product-one-of-three" : index % 3 === 1 ? "product-two-of-three": "product-three-of-three last"
        }
    }

    return (
        <>
            <TitleCtn tituloVitrine={tituloVitrine} />

            <div className="container">
                <div className={`macro-vitrine-mostruario-oferta-limitada-seis-produtos${className} ${vitrineMacro}`}>
                    {Object.values(produtos).map((produto, index) => (
                        <div className={`produto-oferta ${getAClass(index)}`} key={produto.produto_id}>
                            <a href={getLinkProduto(produto)}>
                                <div className="imagem-produto">
                                    <MidiaProdutoVitrine
                                        hostImagem={hostImagem}
                                        produto={produto}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                    />

                                    {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                                </div>

                                <div className="conteudo-oferta">
                                    <span className="product-name">
                                        {produto.titulo || produto.nome}
                                    </span>

                                    {exibeValoresSomenteLogado ? (
                                        <div className="dados-produto">
                                            <div className="valores-logados-vitrine">
                                                <span>
                                                    Faça login para ver os preços
                                                </span>

                                                <a href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`} className="btn-comprar-vitrine flex center justify-center">
                                                    Fazer login
                                                </a>
                                            </div>
                                        </div>
                                    ) : (
                                        <DadosProduto produto={produto} precoPrincipal={precoPrincipal} vitrineButtonAddToCart={vitrineButtonAddToCart}/>
                                    )}
                                </div>
                            </a>

                            {(!exibeValoresSomenteLogado && (produto.data_fim || Boolean(exibeQuantidadeEstoque))) ? (
                                <div className="dados-footer">
                                    {Boolean(exibeQuantidadeEstoque) && (
                                        <div className="oferta-restante">
                                            <span className="quantidade-desc">Quantidade</span>
                                            <span className="quantidade">{produto.qtde_estoque}</span>
                                        </div>
                                    )}

                                    {produto.data_fim && (
                                        <Counter dataFim={produto.data_fim} />
                                    )}
                                </div>
                            ) : null}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}